import { render } from "./salaryadjustmentreport.vue?vue&type=template&id=adcb8ba4"
import script from "./salaryadjustmentreport.vue?vue&type=script&lang=js"
export * from "./salaryadjustmentreport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__